import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styles from './SearchStatus.module.scss';

type Props = {
    clear: (event: any) => void;
    itemCount: number;
    search: string;
};

const SearchStatus = ({ clear, itemCount = 0, search = '' }: Props) => {
    if (!search) {
        return null;
    }

    return (
        <div className={styles['search-status']}>
            <div className={styles.match}>
                <span className={styles['results-for']}>
                    <FormattedMessage id="results_for" values={{ count: `${itemCount}` }} />
                    <span className={styles.search}> {search}</span>
                    <span className={styles.clear} onClick={clear}>
                        <FormattedMessage id="clear" />
                    </span>
                </span>
            </div>
            {!itemCount && (
                <div className={styles['no-match']}>
                    <FormattedMessage id="try_another_search" />
                </div>
            )}
        </div>
    );
};

export default React.memo<Props>(SearchStatus, isEqual);
